<template>
  <div class="back-pass container">

    <div style="height: 80px"></div>
    <div class="item flex">
      <div class="name">手机号</div>
      <el-input v-model.number="tel" placeholder="点击输入手机号" :disabled="codeDisabled" style="width: 300px" />
    </div>
    <div style="height: 20px"></div>
    <div class="item flex">
      <div class="name">验证码</div>
      <el-input v-model.number="code" style="width: 120px" />
      <div style="width: 40px"></div>
      <el-button type="info" :disabled="codeDisabled"  @click="getCode" :loading="codeLoading">{{codeBtnTxt}}</el-button>
    </div>
    <div style="height: 20px"></div>
    <div class="item flex">
      <div class="name">新密码</div>
      <el-input v-model="pass1" type="password" placeholder="点击输入密码" style="width: 300px" />
    </div>
    <div style="height: 20px"></div>
    <div class="item flex">
      <div class="name">确认密码</div>
      <el-input v-model="pass2" type="password" placeholder="点击输入密码" style="width: 300px" />
    </div>
    <div style="height: 40px"></div>
    <el-button type="primary" size="large" :loading="postLoading" class="regTel" @click="regTel">修改密码</el-button>
    <div style="height: 60px"></div>
  </div>
</template>

<script>
import { reactive, toRefs, onBeforeUnmount } from "vue"
import { ElMessage, ElNotification } from 'element-plus'
import { validateTel } from "@/tools"
import { useRouter } from "vue-router"
import { api } from '@/api'
export default {
  name: "backPass",
  setup() {
    const Router = useRouter()
    let initData = reactive({
      tel: "",
      pass1: "",
      pass2: "",
      // 验证码 -- start -- 
      code: "",
      codeDisabled: false,
      codeTime: 120,
      codeLoading: false,
      codeBtnTxt: "获取验证码",
      timer: "",
      // 验证码 -- end -- 
      postLoading: false,
      uid: ""
    })
    // 获取验证码
    function getCode() {
      if(validateTel(initData.tel)) {
        initData.codeLoading = true
        initData.codeDisabled = true
        // 获取验证码
        api("get", "smsSignCodeByPc", {phone: initData.tel, type: 1, appcode: '5101'})
          .then(res => {
            initData.codeLoading = false
            if(res.code === 1200) {
              initData.uid = res.data.uid
              ElNotification({
                title: '提示',
                message: '验证码已发送到手机，请注意查收.',
                type: 'success',
              })
              initData.codeTime = 120
              initData.timer = setInterval(() => {
                if(initData.codeTime === 0) {
                  initData.codeDisabled = false
                  initData.codeBtnTxt = "获取验证码"
                  clearInterval(initData.timer)
                  initData.timer = null
                } else {
                  initData.codeTime -= 1
                  initData.codeBtnTxt = `重新获取 ${initData.codeTime} S`
                }
              }, 1000)
            } else {
              ElNotification({
                title: '提示',
                message: res.msg,
                type: 'error',
              })
            }
          })
          .catch(err => {
            initData.codeLoading = false
            ElNotification({
              title: '提示',
              message: '验证码获取失败！请重新尝试.',
              type: 'error',
            })
          })
      } else {
        ElMessage.warning('请输入正确的手机号码.')
      }
    }
    // 验证手机号是否可用
    function regTel() {
      if(initData.code) {
        initData.postLoading = true
        // console.log(api("get", "checkSmsCode", {phone: initData.tel, smsCode: initData.code}))
        // return
        api("get", "checkSmsCode", {phone: initData.tel, smsCode: initData.code})
          .then(res => {
            if(res.code === 1200) {
              handlebtn()
            } else {
              initData.postLoading = false
              ElNotification({
                title: '提示',
                message: res.msg,
                type: 'error',
              })
            }
          })
          .catch(err => {
            initData.postLoading = false
            ElNotification({
              title: '提示',
              message: '验证码校验失败！请重新尝试.',
              type: 'error',
            })
          })
      } else {
        initData.postLoading = false
        ElMessage.warning('请输入短信验证码.')
      }
    }
    // 更改密码
    function handlebtn() {
      
      if(initData.pass1.length < 4 || initData.pass1.length > 16) {
        initData.postLoading = false
        ElMessage.warning('请输入4至16位长度的密码.')
      } else if(initData.pass1 !== initData.pass2) {
        initData.postLoading = false
        ElMessage.warning('两次密码不一致.')
      } else { // password
        let data = {
          id: initData.uid,
          newPassword: initData.pass1,
          oldPassword: '123456',
          type: '2'
        }
        api("post", "password", data)
          .then(res => {
            if(res.code === 1200) {
              ElNotification({
                title: '提示',
                message: '密码重置成功.',
                type: 'success',
              })
              Router.push({
                path: "/"
              })
            } else {
              initData.postLoading = false
              ElNotification({
                title: '提示',
                message: res.msg,
                type: 'error',
              })
            }
          })
          .catch(err => {
            initData.postLoading = false
            ElNotification({
              title: '提示',
              message: '密码重置失败！请重新尝试.',
              type: 'error',
            })
          })
      }
    }
    onBeforeUnmount(() => {
      if(initData.timer) clearInterval(initData.timer)
    })
    return {
      ...toRefs(initData),
      getCode,
      regTel,
      
    }
  }
}
</script>
<style>
.header {
  border-bottom: 2px solid #F6F6F6;
  box-sizing: border-box;
}
</style>
<style lang="less" scoped>
.back-pass {
  padding-left: 700px;
}
.item {
  width: 500px;
  align-items: center;
  .name {
    width: 80px;
    color: #585858;
  }
}
.regTel {
  width: 200px;
  margin-left: 80px;
}
</style>